import layout from '@/views/layout/layout.vue'
const activityUserGrantyList = r => require.ensure([], () => r(require('@/views/marketing/activityUserGrant/list.vue')), 'group-marketing-activity')
const apendedUserGrantyList = r => require.ensure([], () => r(require('@/views/marketing/activityUserGrant/apendedUser.vue')), 'group-marketing-activity')

const marketingActivityUserGranty = [
  {
    path: '/marketing/activityUserGrant',
    name: 'marketing-activityUserGrant',
    component: layout,
    redirect: '/marketing/activityUserGrant/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: activityUserGrantyList,
        name: 'marketing-activityUserGrant-list',
        meta: {
          displayName: '待审核用户',
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/marketing/activityUserGrant',
    name: 'marketing-activityUserGrant',
    component: layout,
    redirect: '/marketing/activityUserGrant/apendedUser',
    hidden: true,
    children: [
      {
        path: 'apendedUser',
        component: apendedUserGrantyList,
        name: 'marketing-activityUserGrant-apendedUser',
        meta: {
          displayName: '已审核用户',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingActivityUserGranty



// WEBPACK FOOTER //
// ./src/router/marketing/activityUserGrant.js